import React from 'react';
import { Controller } from 'react-hook-form';
import { Radio } from "../radio/Radio.js";
import { RadioGroup } from "../radioGroup/RadioGroup.js";

// ToDo: Get rid of internal proxy input prop type -> Breaking change for next major version
import { jsx as _jsx } from "react/jsx-runtime";
export function FormRadioGroup({
  control,
  name,
  rules,
  defaultValue,
  radioGroupProps
}) {
  const {
    children,
    ...rest
  } = radioGroupProps;
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    rules: rules,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        name,
        value
      },
      fieldState: {
        error
      }
    }) =>
    /*#__PURE__*/
    // @ts-expect-error Lazyness :(
    _jsx(RadioGroup, {
      ...rest,
      name,
      value,
      onChange: e => {
        onChange(e);
        radioGroupProps.onChange?.(e);
      },
      error: error?.message,
      children: children.map((option, index) => /*#__PURE__*/_jsx(Radio, {
        ...option
      }, index))
    })
  });
}